import { render, staticRenderFns } from "./RequiredMark.vue?vue&type=template&id=7937132d&"
import script from "./RequiredMark.vue?vue&type=script&lang=js&"
export * from "./RequiredMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports